import React from 'react';
import {
    FullScreen,
    useFullScreenHandle,
} from "react-full-screen";
import Viewer from './Viewer';

export default function ViewerApp() {
    const handle = useFullScreenHandle();
    const toggleFullScreen = () => {
        handle.active ? handle.exit() : handle.enter();
    };

    return (
        <FullScreen handle={handle}>
            <Viewer
                toggleFullScreen={toggleFullScreen}
                fullScreen={handle.active}
            />
        </FullScreen>
    );
}
